// Nudges and suggestions (E01-S4-T2; D-05, contracts 1.0 section 4). A nudge is what a tripwire
// firing becomes: rendered, cited text and ids. It has no field that could hold a frame value, and
// its text is already rendered — a placeholder left in it is a rendering bug, not content.
import { z } from "zod";
import { Citation } from "../citation.js";
import { Count, Id, IsoUtc, NonEmpty, strictObject } from "../primitives.js";
import { SopStepRef, TripwireHighlight, TripwireSeverity } from "../tripwire.js";
// NudgeId lives in client.ts, beside the client nudge event, so client.ts never imports this file.
import { NudgeId, nudgeIdNames, SurfaceAction } from "./client.js";
/** Rendered text: authored text with every `{path}` already filled in. */
const Rendered = NonEmpty.refine((s) => !/\{[^{}]*\}/.test(s), "a nudge carries rendered text: no {placeholder} may remain");
export const Nudge = strictObject({
    id: NudgeId,
    tripwireId: Id,
    severity: TripwireSeverity,
    text: Rendered,
    short: Rendered,
    citation: Citation,
    highlight: TripwireHighlight.optional(),
    beat: Id.optional(),
    sopStep: SopStepRef.optional(),
    raisedAt: IsoUtc,
    frameSeq: Count,
    shown: z.boolean(), // false: the attention budget held it back (D-95)
    acknowledgedAt: IsoUtc.optional(),
}).superRefine((n, ctx) => {
    if (!nudgeIdNames(n.id, n.tripwireId))
        ctx.addIssue({
            code: "custom",
            message: "a nudge id is <tripwireId>#<n> for its own tripwire (D-05)",
            path: ["id"],
        });
    if (n.acknowledgedAt !== undefined && Date.parse(n.acknowledgedAt) < Date.parse(n.raisedAt)) {
        ctx.addIssue({
            code: "custom",
            message: "a nudge is acknowledged after it is raised",
            path: ["acknowledgedAt"],
        });
    }
});
/** A button under a sentence: a label and the surface action it sends (D-05). */
export const Suggestion = strictObject({ id: NonEmpty, label: NonEmpty, action: SurfaceAction });
//# sourceMappingURL=nudge.js.map